import { apiHelper, sharedHelper, sessionHelper } from '@/utils'
import { API } from '@/constants'

export const companyDisplayImageService = {
    getAllDisplayImages,
    createDisplayImage,
    updateDisplayImage
};

const MODULE = {
    DISPLAY: 'company-display-images',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllDisplayImages(filter) {
    const requestOptions = {
        params: {
            page: filter.pageNumber,
            size: filter.pageSize,
            isActive: filter.isActive,
        }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`
            requestOptions.params[searchParam] = word
        }
    })

    if (sessionHelper.getUserType == "STAFF") {
        requestOptions.params['company'] = sessionHelper.getStaffCompanyUUID()
    }

    return apiHelper(API_URL).get(`/${MODULE.DISPLAY}`, requestOptions)
}


export function createDisplayImage(data) {
    const formData = new FormData();
    sharedHelper.appendIfNotNull(formData, 'company_uuid', data.companyID);

    data.images.forEach((image, index) => {
        if (image instanceof File) {
            formData.append(`images[${index}]`, image);
        } else {
            console.warn(`Image at index ${index} is not a File object`);
        }
    });

    return apiHelper(API_URL).post(`/${MODULE.DISPLAY}`, formData)
}


export function updateDisplayImage(data) {
    const requestOptions = {
        is_active: data.isActive
    }

    return apiHelper(API_URL).patch(`/${MODULE.DISPLAY}/${data.id}`, requestOptions)
}

